/* eslint-disable react-hooks/exhaustive-deps */
import { AddCircle, Clear, Edit, Search } from "@mui/icons-material";
import { Box, Button, Card, CardContent, Grid, Tooltip } from "@mui/material";
import { GridActionsCellItem, GridRowId, GridRowModel, GridSortModel, GridSortDirection } from "@mui/x-data-grid";
import React, { useEffect, useMemo, useState } from "react";
import { format } from "date-fns";

import AutoComplete from "../../../components/hookForms/autoComplete";
import { Container } from "../../../theme/globalStyles";
import DataTable from "../../../components/dataTable";
import DialogNew from "./modal/dialogAdd";
import DialogEdit from "./modal/dialogEdit";
import TextInput from "@/components/hookForms/textField";
import messages from "../../../utils/messages";
import serviceUsuario from "@/services/serviceUsuario";
import { toast } from "react-toastify";
import { useAuth } from "../../../context/global";
import { useForm } from "react-hook-form";

// import { Container } from './styles';

const Usuario: React.FC = () => {
    const { setTitlePage } = useAuth();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [rowCount, setRowCount] = useState(10);
    const [page, setPage] = useState(0);
    const [filters, setFilters] = useState(null);
    const [pageSize, setPageSize] = useState(100);
    const [data, setData] = useState<any[]>([]);
    const [openModalAdd, setOpenModalAdd] = useState<boolean>(false);

    const [sortModel, setSortModel] = useState<GridSortModel>([
        {
            field: "",
            sort: "" as GridSortDirection,
        },
    ]);

    const [editState, setEditState] = useState({
        open: false,
        usuarioID: 0,
        email: "",
        perfil: "",
        ativo: "",
        perfilTemporario: "",
        dataInicioPerfilTemporario: null,
        dataFimPerfilTemporario: null,
        nome: "",
    });

    useEffect(() => {
        setTitlePage("Cadastro - Usuários");
    }, [setTitlePage]);

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        defaultValues: {
            email: "",
            perfil: "",
            ativo: "",
        },
    });

    const listPerfis = [
        { value: "Admin", label: "Admin" },
        { value: "Master", label: "Master" },
        { value: "OeM", label: "OeM" },
        { value: "Consulta", label: "Consulta" },
        { value: "Regular", label: "Regular" },
        { value: "ComercialPreVendas", label: "ComercialPreVendas" },
    ];

    const ativoList = [
        { value: "S", label: "Sim" },
        { value: "N", label: "Não" },
    ];

    const actionColumns = useMemo(
        () => [
            {
                headerName: "Operações",
                field: "operations",
                type: "actions",
                width: 120,
                hide: false,
                getActions: (params: { id: GridRowId; row: GridRowModel }) => [
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Editar">
                                <Edit />
                            </Tooltip>
                        }
                        label="Editar"
                        onClick={() =>
                            setEditState({
                                open: true,
                                usuarioID: params.row.usuarioID,
                                email: params.row.email,
                                perfil: params.row.perfil,
                                ativo: params.row.ativo,
                                perfilTemporario: params.row.perfilTemporario,
                                dataInicioPerfilTemporario: params.row.dataInicioPerfilTemporario,
                                dataFimPerfilTemporario: params.row.dataFimPerfilTemporario,
                                nome: params.row.nome,
                            })
                        }
                        //Usuários de serviços não podem ser editáveis
                        disabled={
                            params.row.email === "recepcaofatura@reenergisa.com.br" ||
                            params.row.email === "sankhya@reenergisa.com.br" ||
                            params.row.email === "rebalance@reenergisa.com.br" ||
                            params.row.email === "servicocarga@energisaterceiros.com.br"
                        }
                    />,
                ],
            },
        ],
        []
    );

    const columns = useMemo(
        () => [
            {
                headerName: "ID",
                field: "usuarioID",
                type: "number",
                headerAlign: "left",
                identity: true,
                width: 70,
            },
            {
                headerName: "Nome",
                field: "nome",
                type: "string",
                width: 230,
            },
            {
                headerName: "E-mail",
                field: "email",
                type: "string",
                width: 320,
            },
            {
                headerName: "Perfil permanente",
                field: "perfil",
                type: "string",
                width: 150,
            },
            {
                headerName: "Ativo",
                field: "ativo",
                type: "string",
                width: 80,
            },
            {
                headerName: "Perfil temporário",
                field: "perfilTemporario",
                type: "string",
                width: 150,
                valueGetter: (params: { row: GridRowModel }) => {
                    if (
                        params.row.dataFimPerfilTemporario &&
                        params.row.dataInicioPerfilTemporario &&
                        params.row.perfilTemporario
                    ) {
                        return `${params.row.perfilTemporario} - De ${format(
                            new Date(params.row.dataInicioPerfilTemporario),
                            "dd/MM/Y"
                        )} - Até ${format(new Date(params.row.dataFimPerfilTemporario), "dd/MM/Y")}`;
                    }
                    return "-";
                },
            },

            ...actionColumns,
        ],
        [actionColumns]
    );

    const getAllWithFilters = async (filters: any) => {
        setData([]);
        setIsLoading(true);

        serviceUsuario
            .getWithFilter({
                ...filters,
                take: pageSize,
                currentPage: page + 1,
                sortExpression: sortModel[0]?.field ?? "",
                sortDirection: sortModel[0]?.sort ?? "",
            })
            .then((result) => {
                setData(result?.data.content);
                setRowCount(4);
            })
            .catch((err) => {
                toast.error(messages.getWithFilterError, err);
                setData([]);
                setRowCount(0);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    useEffect(() => {
        getAllWithFilters(null);
    }, [page, pageSize, sortModel]);

    const onSubmit = (values: any) => {
        setFilters(values);
        getAllWithFilters(values);
    };

    const onClear = () => {
        reset({ email: "", perfil: "", ativo: "" });
        getAllWithFilters(null);
    };

    const onSuccessAction = () => {
        getAllWithFilters(filters);
    };

    return (
        <Container>
            <Card>
                <CardContent>
                    <Box sx={{ mb: 2 }}>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Grid container spacing={2}>
                                <Grid item md={6}>
                                    <Grid container spacing={2}>
                                        <Grid item md={4}>
                                            <TextInput name="email" label="E-mail" control={control} error={errors} />
                                        </Grid>
                                        <Grid item md={4}>
                                            <AutoComplete
                                                name="ativo"
                                                label="Ativo"
                                                options={ativoList}
                                                control={control}
                                                error={errors}
                                            />
                                        </Grid>
                                        <Grid item md={4}>
                                            <AutoComplete
                                                name="perfil"
                                                label="Perfil"
                                                options={listPerfis}
                                                control={control}
                                                error={errors}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item md={6}>
                                    <Grid container spacing={2}>
                                        <Grid item md={4}>
                                            <Button
                                                disableElevation
                                                variant="contained"
                                                color="warning"
                                                fullWidth
                                                style={{ margin: "16px 0px 8px 0px" }}
                                                startIcon={<Search />}
                                                type="submit"
                                                disabled={isLoading}
                                            >
                                                Pesquisar
                                            </Button>
                                        </Grid>
                                        <Grid item md={4}>
                                            <Button
                                                disableElevation
                                                variant="outlined"
                                                color="warning"
                                                fullWidth
                                                style={{ margin: "16px 0px 8px 0px" }}
                                                startIcon={<Clear />}
                                                onClick={() => onClear()}
                                            >
                                                Limpar
                                            </Button>
                                        </Grid>
                                        <Grid item md={4}>
                                            <Button
                                                style={{ marginTop: 16, marginBottom: 8 }}
                                                variant="contained"
                                                color="primary"
                                                startIcon={<AddCircle />}
                                                onClick={() => setOpenModalAdd(true)}
                                                disableElevation
                                                fullWidth
                                                size="medium"
                                            >
                                                Novo
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </form>
                    </Box>

                    <Box sx={{ height: 450, marginTop: "24px" }}>
                        <DataTable
                            columns={columns}
                            rows={data}
                            rowId={(row: GridRowModel) => row.usuarioID}
                            rowCount={rowCount}
                            isLoading={isLoading}
                            onPageChange={(currentPage: number) => setPage(currentPage)}
                            onPageSizeChange={(currentPageSize: number) => setPageSize(currentPageSize)}
                            pageSize={pageSize}
                            onSortModelChange={(model: GridSortModel) => setSortModel(model)}
                        />
                    </Box>
                </CardContent>
            </Card>

            <DialogNew open={openModalAdd} onSuccess={() => onSuccessAction()} onClose={() => setOpenModalAdd(false)} />

            <DialogEdit
                open={editState.open}
                onSuccess={() => onSuccessAction()}
                props={editState}
                onClose={() =>
                    setEditState({
                        open: false,
                        usuarioID: 0,
                        email: "",
                        perfil: "",
                        ativo: "",
                        perfilTemporario: "",
                        dataInicioPerfilTemporario: null,
                        dataFimPerfilTemporario: null,
                        nome: "",
                    })
                }
            />
        </Container>
    );
};

export default Usuario;
